<div
	#loadingTagCol
	class="loading-tag-col"
	[style.flex-direction]="orientation === 'horizontal' ? 'column' : 'row'"
	[style.align-items]="orientation === 'vertical' ? 'flex-end' : 'flex-start'">
	@for (empty of [].constructor(calculatedQuantity); let index = $index; track index) {
		<div
			[ngClass]="orientation"
			[ngStyle]="orientation === 'horizontal' ? { height: barThickness } : { width: barThickness }"
			[style.--bar-index]="index"
			[style.--bar-quantity]="calculatedQuantity"
			[style.--variancia]="variancias[index]"
			[style.--animation-speed]="animationSpeed"></div>
	}
</div>
